/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_DisclaimerInputs */

const en_home_bench_disclaimer = /** @type {(inputs: Home_Bench_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample data. No messages are sent.`)
};

const lv_home_bench_disclaimer = /** @type {(inputs: Home_Bench_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parauga dati. Ziņojumi netiek sūtīti.`)
};

/**
* | output |
* | --- |
* | "Sample data. No messages are sent." |
*
* @param {Home_Bench_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_disclaimer = /** @type {((inputs?: Home_Bench_DisclaimerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_DisclaimerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_disclaimer(inputs)
	return en_home_bench_disclaimer(inputs)
});